import React from "react";
import "./Education.scss";
import {Fade} from "react-reveal";
import educationBooks from "../../assets/lottie/education";
import {illustration} from "../../portfolio";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
// import rait from "../../assets/images/dyp-rait.png";
// import pace from "../../assets/images/pace.png";
import {
    Timeline,
    Container,
    YearContent,
    BodyContent,
    Section,
    Description,
   } from 'vertical-timeline-component-react';

const customTheme = {
  yearColor: '#405b73',
  lineColor: '#008080',
  dotColor: '#008080',
  borderDotColor: '#000000',
  titleColor: '#000000',
  subtitleColor: '#868e96',
  textColor: '#000000',
 };

export default function Education() {
  return (
    <div className="main" id="education">
      <div className="education-main-div">
        <Fade left duration={1000}>
        <div className="education-text-div">
            <h1 className="education-heading">Education</h1>
            <Timeline dateFormat='ll'>
                <Container>
                    <YearContent startDate='2016/08/12' endDate='2020/10/17' />
                    <BodyContent>
                        <Section title='University of Mumbai'>
                            <Description variant='subtitle' text='B.E. in Computer Engineering @ Ramrao Adik Institute of Technology' />
                            <strong><Description variant='subtitle' text='CGPA: 9.12/10' /></strong>
                            <Description variant='subtitle' text="Activities: Coders' Club, Computer Society of India" /><br /><br />
                        </Section>
                    </BodyContent>
                </Container>
                <Container>
                    <YearContent startDate='2014/07/21' endDate='2016/03/06' />
                    <BodyContent>
                        <Section title=' The Kelkar Education Trust, V.G. Vaze College'>
                            <Description variant='subtitle' text='Higher Secondary Certificate, Science' /><br /><br />
                        </Section>
                    </BodyContent>
                </Container>
                <Container>
                    <YearContent startDate='2011/07/14' endDate='2001/04/08' />
                    <BodyContent>
                        <Section title='B.P.E.S High School'>
                            <Description variant='subtitle' text='Secondary School Certificate' />
                            <Description variant='subtitle' text='Activities: Inter-school chess championship, Olympiad Mathematics' /><br /><br />
                        </Section>
                    </BodyContent>
                </Container>
            </Timeline>
        </div>
        </Fade>
		<Fade right duration={1000}>
          <div className="education-image-div">
            {illustration.animated ? (
              <DisplayLottie animationData={educationBooks} />
            ) : (
              <img
                alt="Man Working"
                src={require("../../assets/images/developerActivity.svg")}
              ></img>
            )}
          </div>
        </Fade>
      </div>
    </div>
  );
}